import { useTransportQuery } from "@/transport"

import type { FlexibleDashboardDrilldownRequest } from "@/types_api/backend/transport/flexible_dashboard_drilldown_request"
import type { HumanReviewDrilldownRequest } from "@/types_api/backend/transport/human_review_drilldown_request"
import type { MetricValuesBySimulationRequest } from "@/types_api/backend/transport/metric_values_by_simulation_request"

interface QueryOptions {
  enabled?: boolean
  staleTime?: number
  gcTime?: number
}

export function useFlexibleDashboardDrilldownTransportQuery({
  request,
  options,
}: {
  request: FlexibleDashboardDrilldownRequest
  options?: QueryOptions
}) {
  return useTransportQuery({
    operation: "flexibleDashboardDrilldown",
    request,
    options,
  })
}

export function useHumanReviewDashboardDrilldownTransportQuery({
  request,
  options,
}: {
  request: HumanReviewDrilldownRequest
  options?: QueryOptions
}) {
  return useTransportQuery({
    operation: "humanReviewDashboardDrilldown",
    request,
    options,
  })
}

export function useMetricValuesBySimulationTransportQuery({
  request,
  options,
}: {
  request: MetricValuesBySimulationRequest
  options?: QueryOptions
}) {
  return useTransportQuery({
    operation: "metricValuesBySimulation",
    request,
    options,
  })
}
